module.exports = __webpack_public_path__ + "img/bulleted-list.7c10f0ce.svg";